import { render } from "./WorkspaceCreateModal.vue?vue&type=template&id=51369f15"
import script from "./WorkspaceCreateModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceCreateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__